import Link  from 'next/link'
import { Media } from 'react-bootstrap'
import styles from './dashboard.module.css'
import { IoLogoFacebook } from 'react-icons/io'
import Image from 'next/image'

function UpcomingEvent({eventLink, allEventsLink, eventImg, eventDate,  eventTitle, textColor, bgColor}) {
    return (
        
        <div className="upcomingEvent d-flex justify-content-center py-4 px-3 bg-lighter-gray">
            <Media className={`${styles.upcomingEvent_media} flex-md-row flex-column align-items-center position-relative`}>
                <Image src={eventImg} alt="Upcoming Event" width={473} height={247} layout="intrinsic" />
                <Media.Body className="mt-md-0 mt-3 ml-md-4">
                    <h4 className="mb-3"><strong>Upcoming Event</strong> 
                    <Link href="/events">
                        <a className="fbLive position-absolute">
                            <span className="icon"><IoLogoFacebook/></span><span className="d-inline-block text-white live position-relative">LIVE</span>
                        </a>
                    </Link></h4>
                    <p>{eventDate}  <br/> {eventTitle}</p>
                    { eventLink ? <a href={eventLink} className={`${bgColor} border d-inline-block rounded-pill btnlearnMore mt-2`}><strong>Learn more</strong></a> : null }
                    { allEventsLink ? <a href={allEventsLink} className={`${textColor} h7 mt-3 d-inline-block ml-4`}><u>View All Events</u></a> : null }
                    
                </Media.Body>
            </Media>
            
            <style jsx>{`
                .btnlearnMore{
                    border-width:3px!important;
                    padding: .4rem 1.8rem;
                    font-size: 1.1rem;
                    transition: .3s;
                }
                .btnlearnMore:hover{
                    transition: .3s;
                    color:#fff;
                    text-decoration:none;

                }
                
                .fbLive{
                    right: 0;
                    line-height: 0;
                }
                .fbLive .icon{
                    color: #3c5a98;
                    font-size: 2rem;
                }
                .fbLive .live{
                    background-color: #ef4244;
                    border-radius: 2px;
                    top: -3.5px;
                    font-size: .85rem;
                    font-weight: 500;
                    padding: 1px 6px;
                    left: -1px;
                    line-height: 1.62;
                }
                @media(min-width:768px){
                    .fbLive{
                        top: 0;
                    }
                }
                @media(max-width:768px){
                    .upcomingEvent__img{
                        width: 45%;
                    }
                }
                @media(max-width:767px){
                    .upcomingEvent__img{
                        width: 100%;
                    }
                }
            `}</style>
        </div>
        
    )
}

export default UpcomingEvent
